import { Link } from "react-router-dom";
import { useSettings } from "@/context/AppContext";
import SEO from "@/components/SEO";
import { PageHero, Reveal, SectionHead } from "@/components/Motion";
import { ArrowUpRight, Globe2 } from "lucide-react";

export default function Markets() {
  const { settings } = useSettings();
  if (!settings) return <div className="min-h-screen bg-forest-deep" />;
  const seo = settings.seo?.pages?.markets;
  const markets = settings.markets || {};

  return (
    <div data-testid="markets-page">
      <SEO title={seo?.title} description={seo?.description} path="/markets" />
      <PageHero eyebrow="Export Markets" title={markets.headline} description={markets.description} image={settings.categories?.tea?.image} />

      <section className="relative overflow-hidden bg-forest-deep py-20 lg:py-28 grain">
        <div className="absolute inset-0 dot-map opacity-30" />
        <div className="relative mx-auto max-w-[1440px] px-4 sm:px-8 lg:px-16">
          <SectionHead dark eyebrow="Regions We Serve" title="Focus regions for export supply." description="Our team coordinates shipments to buyers across these regions. Specific destination details are confirmed during the inquiry process." />
          <div className="mt-14 grid gap-px bg-white/10 sm:grid-cols-2 lg:grid-cols-3">
            {(markets.regions || []).map((r, i) => (
              <Reveal key={r} delay={(i % 3) * 0.08}>
                <div className="group flex h-full items-center gap-5 bg-forest p-8 transition-colors duration-500 hover:bg-forest-mid" data-testid={`market-region-${r.toLowerCase().replace(/\s+/g, "-")}`}>
                  <span className="font-serif italic text-4xl text-gold/40 group-hover:text-gold transition-colors">{String(i + 1).padStart(2, "0")}</span>
                  <div>
                    <h3 className="font-serif text-2xl text-parchment flex items-center gap-2.5"><Globe2 className="h-5 w-5 text-gold" /> {r}</h3>
                    <p className="mt-1.5 text-sm text-[#9EB8A8]">Indian spices, rice and teas for B2B buyers.</p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
          <Reveal className="mt-14">
            <Link to="/quote" data-testid="markets-quote-cta" className="inline-flex items-center gap-2.5 bg-gold px-8 py-4 text-sm font-semibold uppercase tracking-[0.16em] text-forest transition-colors hover:bg-gold-light">
              Discuss Your Market <ArrowUpRight className="h-4 w-4" />
            </Link>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
